import React, { useEffect, useState } from "react";
import ChipSearchInput from "@/components/CustomInput/ChipInputField";
import type { BusinessEcosystemData } from "@/types/companyProfile";
import type { TenantProfilePayload } from "@/types/tenantService";

interface Props {
  formData: TenantProfilePayload;
  setFormData: React.Dispatch<React.SetStateAction<TenantProfilePayload>>;
  data?: BusinessEcosystemData;
  errors?: Record<string, string>;
  setFormErrors?: React.Dispatch<React.SetStateAction<Record<string, string>>>;
}

const BusinessEcosystem: React.FC<Props> = ({
  formData,
  setFormData,
  data,
  errors = {},
  setFormErrors,
}) => {
  const [partnerOptions, setPartnerOptions] = useState<string[]>([]);
  const [salesOptions, setSalesOptions] = useState<string[]>([]);

  useEffect(() => {
    if (data) {
      setFormData((prev) => ({
        ...prev,
        partners: data.partners ?? [],
        salesMethodology: data.salesMethodology ?? [],
      }));

      setPartnerOptions(data.partners ?? []);
      setSalesOptions(data.salesMethodology ?? []);
    }
  }, [data, setFormData]);

  const handleChange = (
    key: keyof TenantProfilePayload,
    newValues: string[],
    setOptions: React.Dispatch<React.SetStateAction<string[]>>,
  ) => {
    setFormData((prev) => ({ ...prev, [key]: newValues }));
    setOptions((prev) => Array.from(new Set([...prev, ...newValues])));

    if (setFormErrors) {
      setFormErrors((prev) => {
        const newErrors = { ...prev };
        if (newValues.length > 0) {
          delete newErrors[key];
        } else {
          newErrors[key] = "This field is required.";
        }
        return newErrors;
      });
    }
  };

  return (
    <div className="text-white space-y-4">
      <ChipSearchInput
        label="Partners"
        values={formData.partners}
        options={partnerOptions}
        onChange={(newValues) =>
          handleChange("partners", newValues, setPartnerOptions)
        }
        error={errors.partners}
      />

      <ChipSearchInput
        label="Sales Methodology"
        values={formData.salesMethodology}
        options={salesOptions}
        onChange={(newValues) =>
          handleChange("salesMethodology", newValues, setSalesOptions)
        }
        error={errors.salesMethodology}
      />
    </div>
  );
};

export default BusinessEcosystem;
